import { subscribed, unsubscribed } from '../actions/app';
import { appConstants } from '../constants';
import { produce } from 'immer';

const initialState = {
	initialized: false,
	subscribed: false,
};

const appReducer = (state = initialState, action) =>
	produce(state, draft => {
		switch (action.type) {
			case appConstants.INITIALIZED:
				draft.initialized = true;
				break;
			case appConstants.SUBSCRIBED:
				draft.subscribed = true;
				break;
			case appConstants.UNSUBSCRIBE:
				draft.subscribed = false;
				break;
			default:
				break;
		}
	});

export default appReducer;
